var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Label, SpinnerIcon, translate, } from '@lucidlink/uicore';
export const StatusTextSettingUp = ({ 'data-testid': testId, }) => {
    return (_jsx(Label, { color: 'static_info', "data-testid": testId, StartIcon: SpinnerIcon, text: translate('Setting up') }));
};
_react_refresh_temp_1 = StatusTextSettingUp;
$RefreshReg$(_react_refresh_temp_1, "StatusTextSettingUp");
